type GoogleTagManager = {
  initializeGTM: () => void;
  removeGTMTags: () => void;
};

const GTM_SCRIPT_BASE = "www.googletagmanager.com/gtm.js?id=";
const GTM_NO_SCRIPT_BASE = "https://www.googletagmanager.com/ns.html?id=";
const GTM_SCRIPT_IDENTIFIER = "googletagmanager.com/gtm.js";

const getNoScriptSnippet = (gtmKey?: string): string =>
  `<iframe src="${GTM_NO_SCRIPT_BASE}${gtmKey}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const getScriptSnippet = (gtmKey?: string): string => `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmKey}');`;

const useGoogleTagManager = (gtmKey?: string, gtmIsActive?: boolean): GoogleTagManager => {
  const removeExistingTags = (): void => {
    document.querySelectorAll("script, noscript").forEach((element) => {
      const { tagName, innerHTML } = element;

      if (
        (element instanceof HTMLScriptElement &&
          (element.src.includes(GTM_SCRIPT_BASE) || innerHTML.includes(GTM_SCRIPT_IDENTIFIER))) ||
        (element instanceof HTMLElement &&
          tagName === "NOSCRIPT" &&
          innerHTML.includes(GTM_NO_SCRIPT_BASE))
      ) {
        element.remove();
      }
    });
  };

  const createOrRetrieveNoScriptTag = (): HTMLElement | Element => {
    const existingNoScript = document.querySelector("noscript[data-gtm]");
    if (!existingNoScript) {
      const noscript = document.createElement("noscript");
      noscript.innerHTML = getNoScriptSnippet(gtmKey);
      return noscript;
    }
    return existingNoScript;
  };

  const createOrRetrieveScriptTag = (): HTMLElement | Element => {
    const existingScript = document.querySelector("script[data-gtm]");
    if (!existingScript) {
      const script = document.createElement("script");
      script.setAttribute("data-gtm", "true");
      script.innerHTML = getScriptSnippet(gtmKey);
      return script;
    }
    return existingScript;
  };

  const initializeGTM = (): void => {
    if (!gtmKey || !gtmIsActive) {
      removeExistingTags();
      return;
    }
    removeExistingTags();
    document.head.insertAdjacentElement("afterbegin", createOrRetrieveScriptTag());
    document.body.insertAdjacentElement("afterbegin", createOrRetrieveNoScriptTag());
  };

  return { initializeGTM, removeGTMTags: removeExistingTags };
};

export default useGoogleTagManager;
